<div _ngcontent-whw-c5="" class="page-header container-fluid">
  <div _ngcontent-whw-c5="" class="page-title">{{ headerText }}</div>
  <div _ngcontent-whw-c5="" class="page-actions"></div>
</div>
